export default __webpack_public_path__ + "static/media/Sollet.216e3b90.svg";